/**
 * Auth API calls.
 */

import client from './client';

export async function loginApi(email, password) {
  const { data } = await client.post('/auth/login/', { email, password });
  return data.data; // { access, refresh, user }
}

export async function refreshTokenApi(refreshToken) {
  const { data } = await client.post('/auth/refresh/', {
    refresh: refreshToken,
  });
  return data.data; // { access }
}

export async function getUserProfile() {
  const { data } = await client.get('/auth/me/');
  return data.data; // user object
}
